import * as yup from "yup";

export const OptionalAttachmentsSchema = (
    maxUploads: number,
    maxSizeInMB: number,
    acceptedFileTypes: Array<{ mime: string; extensions: Array<string> }>
) =>
    yup.object({
        attachments: yup
            .array()
            .ensure()
            .max(maxUploads)
            .of(
                yup.object({
                    fileName: yup.string().required(),
                    fileBody: yup.mixed<File>().required(),
                    fileSize: yup.number().required(),
                    fileType: yup.string().required(),
                    url: yup.string().required()
                })
            )
            .fileTypes(acceptedFileTypes)
            .filesize(maxSizeInMB * 1024 * 1024)
    });

export const RequiredAttachmentsSchema = (
    maxUploads: number,
    maxSizeInMB: number,
    acceptedFileTypes: Array<{ mime: string; extensions: Array<string> }>
) =>
    yup.object({
        attachments: yup
            .array()
            .ensure()
            .required()
            .max(maxUploads)
            .of(
                yup.object({
                    fileName: yup.string().required(),
                    fileBody: yup.string().required(),
                    fileSize: yup.number().required(),
                    fileType: yup.string().required(),
                    url: yup.string().required()
                })
            )
            .fileTypes(acceptedFileTypes)
            .filesize(maxSizeInMB * 1024 * 1024)
    });

export type OptionalAttachmentsFormValues = yup.InferType<
    ReturnType<typeof OptionalAttachmentsSchema>
>;
export type RequiredAttachmentsFormValues = yup.InferType<
    ReturnType<typeof RequiredAttachmentsSchema>
>;

export type AttachmentsFormValues =
    | OptionalAttachmentsFormValues
    | RequiredAttachmentsFormValues;
